import type { LocalStorageService } from './local-storage.service';

export const SELECTED_ENTERPRISE_ID_KEY = 'selectedEnterpriseId';
export const LEGACY_ENTERPRISE_ID_KEY = 'enterpriseId';

/** Copies legacy `enterpriseId` into `selectedEnterpriseId` when the canonical key is empty. */
export function migrateLegacyEnterpriseId(storage: LocalStorageService): void {
    const canonical = storage.getItem<string>(SELECTED_ENTERPRISE_ID_KEY)?.trim();
    if (canonical) {
        storage.removeItem(LEGACY_ENTERPRISE_ID_KEY);
        return;
    }

    const legacy = storage.getItem<string>(LEGACY_ENTERPRISE_ID_KEY)?.trim();
    if (legacy) {
        storage.setItem(SELECTED_ENTERPRISE_ID_KEY, legacy);
    }
    storage.removeItem(LEGACY_ENTERPRISE_ID_KEY);
}

export function getStoredEnterpriseId(storage: LocalStorageService): string | null {
    migrateLegacyEnterpriseId(storage);
    const id = storage.getItem<string>(SELECTED_ENTERPRISE_ID_KEY)?.trim();
    return id || null;
}
